function setBannerDimensions() {
  var cards = document.querySelectorAll('[data-bayu-stl-card]');
  cards.forEach(function (card) {
    var cardWidth = card.offsetWidth;
    var bannerWidth = cardWidth - 20; // 10px margin on each side
    if (window.matchMedia('(max-width: 750px)').matches) {
      bannerWidth = cardWidth - 10; // 5px margin on each side - mobile screen
    }
    var banners = card.querySelectorAll('.bayu-stl__product-banner');
    banners.forEach(function (banner) {
      banner.style.width = bannerWidth + 'px';
      const bannerHeight = banner.offsetHeight;
      banner.style.setProperty('--stl-banner-height', bannerHeight + 'px');
    });
  });
}

function initBannerDimensions() {
  setBannerDimensions();

  var cards = document.querySelectorAll('[data-bayu-stl-card]');

  if (window.ResizeObserver) {
    var ro = new ResizeObserver(function () {
      setBannerDimensions();
    });
    cards.forEach(function (card) {
      ro.observe(card);
    });
  } else {
    window.addEventListener('resize', setBannerDimensions);
  }
}

function initMobileHotspots() {
  document.querySelectorAll('[data-hotspot]').forEach(function (hotspot) {
    hotspot.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 750px)').matches) {
        e.preventDefault();
      }
    });
  });
}

function initBannerLinks() {
  document.querySelectorAll('.bayu-stl__product-banner').forEach(function (banner) {
    var link = banner.dataset.productUrl;
    if (link) {
      banner.addEventListener('click', function () {
        window.location.href = link;
      });
    }
  })
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initBannerDimensions();
    initMobileHotspots();
    initBannerLinks();
  });
} else {
  initBannerDimensions();
  initMobileHotspots();
  initBannerLinks();
}
